// Deep links for the dashboard's quick-action shortcuts.
export const quickActions = [
  { label: "New quotation", path: "/admin/quotation" },
  { label: "New sales order", path: "/admin/sales-order" },
  { label: "Approved Sales Orders", path: "/admin/sales-orders?tab=approved" },
  { label: "Approved Quotations", path: "/admin/quotations?tab=accepted" },
];
